import { parseConsecutiveTemplateSlots } from './whatsappTemplateSlots';
import type { WhatsAppTemplateVariableMapping } from '../../models/MasterAdmin/whatsappHub';

function cleanText(value: unknown): string {
  const text = String(value ?? '').trim();
  return /^(null|undefined)$/i.test(text) ? '' : text;
}

function sanitizeMapping(m: WhatsAppTemplateVariableMapping, slot: number): WhatsAppTemplateVariableMapping {
  const sourceType =
    m.sourceType === 'static' || m.sourceType === 'deep_link' ? m.sourceType : 'context';
  const contextKey = cleanText(m.contextKey);
  const label = cleanText(m.label) || contextKey || `Variable ${slot}`;
  return {
    ...m,
    slot,
    sourceType,
    label,
    contextKey: sourceType === 'context' ? contextKey || null : null,
    staticValue: sourceType === 'static' ? cleanText(m.staticValue) : '',
    deepLinkCampaignId:
      sourceType === 'deep_link' ? cleanText(m.deepLinkCampaignId) || null : null,
    deepLinkUrlType: sourceType === 'deep_link' ? m.deepLinkUrlType || 'short' : undefined,
    deepLinkParamBindings: { ...(m.deepLinkParamBindings || {}) },
  };
}

/** Build empty editable mapping rows for a template with N variables. */
export function emptyMappingsForVariableCount(
  count: number,
  campaignType: 'BROADCAST' | 'AUTOMATED' = 'BROADCAST'
): WhatsAppTemplateVariableMapping[] {
  if (count <= 0) return [];
  return Array.from({ length: count }, (_, i) => ({
    slot: i + 1,
    label: `Variable ${i + 1}`,
    contextKey: null,
    sourceType: campaignType === 'AUTOMATED' ? 'context' : 'static',
    staticValue: '',
    deepLinkCampaignId: null,
    deepLinkUrlType: 'short' as const,
    deepLinkParamBindings: {},
  }));
}

export function cloneTemplateMappings(
  mappings: WhatsAppTemplateVariableMapping[] | undefined | null
): WhatsAppTemplateVariableMapping[] {
  return (mappings || []).map((m, index) =>
    sanitizeMapping(m, Number(m.slot) || index + 1)
  );
}

export function templateHasEditableVariables(
  bodyPreview?: string | null,
  variableCount?: number
): boolean {
  const fromBody = parseConsecutiveTemplateSlots(bodyPreview || '').count;
  return Math.max(fromBody, Number(variableCount) || 0) > 0;
}
